import { FontSize } from './font-size.js'

export * from './font-size.js'

export default FontSize
